import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import {
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-save-preset-dialog",
  templateUrl: "./save-preset-dialog.component.html",
  styleUrls: ["./save-preset-dialog.component.css"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslatePipe
  ]
})
export class SavePresetDialogComponent {
  dialogRef = inject<MatDialogRef<SavePresetDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  enteredName: UntypedFormControl = new UntypedFormControl("");

  constructor() {
    const data = this.data;

    if (data && data.name) {
      this.enteredName.setValue(data.name);
    }
  }

  save() {
    this.dialogRef.close({
      name: this.enteredName.value
    });
  }
}
